const DISALLOWED_REDIRECT_PATHS = ['/login', '/logout', '/signup'];

export const isValidRedirectPath = (path: string | null): boolean => {
    if (!path) {
        return false;
    }

    if (!path.startsWith('/')) {
        return false;
    }

    // Prevent protocol-relative URLs like //evil.com
    if (path.includes('//')) {
        return false;
    }

    const pathWithoutParams = path.split('?')[0].split('#')[0];
    if (DISALLOWED_REDIRECT_PATHS.includes(pathWithoutParams)) {
        return false;
    }

    return true;
};

export const getRedirectPath = (searchParams: URLSearchParams): string | null => {
    const queryReturnTo = searchParams.get('returnTo');
    if (isValidRedirectPath(queryReturnTo)) {
        return queryReturnTo;
    }

    return null;
};

export const buildLoginUrl = (redirectPath: string): string => {
    return `/login?returnTo=${encodeURIComponent(redirectPath)}`;
};
